// Module
var code = `<footer>
    <div class="footer-content">
        <p class="footer-line">
            <span>SPYNE</span>: A structured system for building and evolving applications with AI.
        </p>
        <p class="footer-contact">
            Questions or architectural guidance: <a href="mailto:frank@spynejs.com">frank@spynejs.com</a>
        </p>
    </div>
</footer>
`;
// Exports
module.exports = code;